import { Enlace } from "@/components/Enlace";
import { Img } from "@/components/Img";
// Piezas decorativas del Sistema Cleto: ondas, pinos, marquesina y confeti.
export function Onda({ color, arriba = false }: { color: string; arriba?: boolean }) {
  return (
    <svg className="onda" viewBox="0 0 1440 80" preserveAspectRatio="none" aria-hidden="true" style={{ color, transform: arriba ? "rotate(180deg)" : undefined, marginBottom: -1, marginTop: -1 }}>
      <path d="M0 40 C 180 80 360 0 540 30 S 900 80 1080 40 S 1320 0 1440 30 V80 H0 Z" />
    </svg>
  );
}

export function Pinos() {
  const pino = (x: number, h: number) => `M${x} 120 L${x + h * 0.32} ${120 - h * 0.45} L${x + h * 0.16} ${120 - h * 0.45} L${x + h * 0.4} ${120 - h * 0.75} L${x + h * 0.22} ${120 - h * 0.75} L${x + h * 0.5} ${120 - h} L${x + h * 0.78} ${120 - h * 0.75} L${x + h * 0.6} ${120 - h * 0.75} L${x + h * 0.84} ${120 - h * 0.45} L${x + h * 0.68} ${120 - h * 0.45} L${x + h} 120 Z`;
  const arboles = [[0, 70], [50, 100], [120, 60], [170, 90], [260, 55], [330, 80], [420, 65], [520, 95], [610, 50], [680, 85], [780, 60], [860, 100], [960, 70], [1050, 55], [1120, 90], [1220, 65], [1300, 95], [1380, 60]];
  return (
    <div className="pinos" aria-hidden="true">
      <svg viewBox="0 0 1440 120" preserveAspectRatio="none">
        <path d="M0 120 V100 Q 720 70 1440 100 V120 Z" fill="currentColor" />
        {arboles.map(([x, h], i) => <path key={i} d={pino(x, h)} fill="currentColor" />)}
      </svg>
    </div>
  );
}

export type ItemCinta = { texto: string; href: string; foto?: string };

// Cinta de experiencias: tipografía grande, fotos en píldora y enlaces reales a cada tour.
export function Marquesina({ items, sello }: { items: ItemCinta[]; sello?: string }) {
  const lista = [...items, ...items];
  return (
    <div className="cinta" role="region" aria-label={sello}>
      <div className="cinta-pista">
        {lista.map((it, i) => (
          <Enlace key={i} href={it.href} className="cinta-item" tabIndex={i >= items.length ? -1 : undefined} aria-hidden={i >= items.length ? true : undefined}>
            {it.foto && <span className="cinta-foto"><Img src={it.foto} alt="" loading="lazy" /></span>}
            <span className="cinta-texto">{it.texto}</span>
            <i className="cinta-brujula" aria-hidden="true" />
          </Enlace>
        ))}
      </div>
      {sello && (
        <svg className="cinta-sello" viewBox="0 0 120 120" aria-hidden="true">
          <defs><path id="circulo-sello" d="M60 60 m-44 0 a44 44 0 1 1 88 0 a44 44 0 1 1 -88 0" /></defs>
          <circle cx="60" cy="60" r="58" fill="currentColor" opacity="0" />
          <text><textPath href="#circulo-sello" startOffset="0">{sello} · {sello} ·</textPath></text>
          <path d="M60 36 L66 60 L60 84 L54 60 Z M36 60 L60 54 L84 60 L60 66 Z" className="cinta-aguja" />
        </svg>
      )}
    </div>
  );
}

const coloresConfeti = ["#FFC93C", "#FF7A1A", "#2FA9DF", "#EF5B8C", "#7B5CD6", "#fff"];
export function Confeti({ n = 26 }: { n?: number }) {
  return (
    <div className="confeti" aria-hidden="true">
      {Array.from({ length: n }, (_, i) => (
        <i key={i} style={{ left: `${(i * 37) % 100}%`, background: coloresConfeti[i % coloresConfeti.length], animationDelay: `${(i * 0.37) % 4.5}s`, animationDuration: `${3.5 + (i % 5) * 0.4}s` }} />
      ))}
    </div>
  );
}

export function PortadaModulo({ fondo, video, titulo, sub, cleto, poster, children }: { fondo: string; video?: string; titulo: React.ReactNode; sub: string; cleto: string; poster: string; children?: React.ReactNode }) {
  return (
    <section className="portada-modulo">
      {video ? <video className="fondo" src={video} poster={fondo} autoPlay muted loop playsInline aria-hidden="true" /> : <Img className="fondo" src={fondo} alt="" />}
      <div className="contenedor">
        <div>
          <h1>{titulo}</h1>
          <p className="sub">{sub}</p>
          {children}
        </div>
        <video className="cleto-mod" src={cleto} poster={poster} autoPlay muted loop playsInline aria-hidden="true" />
      </div>
      <Pinos />
    </section>
  );
}
